
import Vue from 'vue';

export default {
    getFondeo(parametros) {
        return Vue.axios.post("pagos/fondeo", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }
}